import { Button, Form, Input } from "antd";

export function VerifyOtpForm({ loading, form, onSubmit }) {
  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      <Form.Item
        label="Nhập OTP"
        name="otp"
        rules={[
          { required: true, message: "Vui lòng nhập mã OTP!" },
          { pattern: /^\d{6}$/, message: "OTP phải là 6 chữ số!" },
        ]}
      >
        <Input.OTP
          size="large"
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "12px",
            width: "100%",
          }}
        />
      </Form.Item>

      <Form.Item>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          loading={loading}
          block
        >
          Xác thực
        </Button>
      </Form.Item>
    </Form>
  );
}
